<template>
  <div>
    <kr-bar :kr="kr" v-if="showKrBar" />
    <old-entity-banner
      @closed="fetchEvents"
      :kr-id="krId"
      class="mb-4"
      v-if="isOldKR && !kr.isClosed"
    />
    <post-kr-updates
      class="mt-3"
      :kr="kr"
      :is-checkin-collapsed="collapseCheckin"
      @post-checkin="onCheckin"
      @commented="trackCommentEvent"
      ref="krUpdates"
    />
    <goal-events
      class="events-section"
      :context="ENTITY_TYPE.KEY_RESULT"
      v-model="events"
      :goal-id="kr.goalId"
      :mentionable-users="usersInScope"
      @awarded="fetchEvents"
      @reply="triggerReply"
    ></goal-events>
  </div>
</template>

<script>
import { trackEvent } from '@/analytics'
import GoalEvents from '@/components/GoalEvents'
import PostKrUpdates from '@/components/kr/PostKrUpdates'
import OldEntityBanner from '@/components/OldEntityBanner'
import { EVENT_ACTION, EVENT_CATEGORY, EVENT_NAME } from '@/constants/analytics'
import { ENTITY_TYPE } from '@/constants/entities'
import events from '@/constants/events'
import { EXT_LOOKUP } from '@/constants/kr'
import { isOlderTimeline } from '@/interval'
import EventBusMixin from '@/mixins/EventBusMixin'
import MembershipsMixin from '@/mixins/MembershipsMixin'
import TeamMixin from '@/mixins/TeamMixin'
import focusEventNode from '@/utils/focusEventNode'
import trackCheckinEvent from '@/utils/goal/trackCheckinEvent'
import showAPIError from '@/utils/showAPIError'
import { mapActions } from 'vuex'
import KrBar from '@/components/kr/KrBar'

export default {
  name: 'KrActivities',
  props: ['krId', 'collapseCheckin', 'source', 'eventToFocus', 'showKrBar'],
  mixins: [MembershipsMixin, EventBusMixin, TeamMixin],
  components: {
    GoalEvents,
    PostKrUpdates,
    OldEntityBanner,
    KrBar
  },
  data() {
    return {
      events: null,
      ENTITY_TYPE,
      isCheckinOverdue: null
    }
  },
  computed: {
    kr() {
      return this.$store.getters.keyResultById(this.krId)
    },
    usersInScope() {
      return this.getUsersInScope(this.goal.teamId, this.goal.organizationId)
    },
    goal() {
      return this.$store.getters.goalById(this.kr.goalId)
    },
    isOldKR() {
      return isOlderTimeline(this.goal.timeline)
    }
  },
  methods: {
    ...mapActions(['getKREvents']),
    async fetchEvents() {
      try {
        this.events = await this.getKREvents({
          orgId: this.kr.organizationId,
          goalId: this.kr.goalId,
          krId: this.kr.id
        })
      } catch (e) {
        showAPIError(e)
      }
    },
    trackCommentEvent() {
      trackEvent(EVENT_CATEGORY.ACTIVITY, EVENT_ACTION.NEW_COMMENT, EVENT_NAME.KR_ACTIVITY_MODAL)
    },
    onCheckin() {
      this.fetchEvents()
      const isLinkedToGoogleSheet = this.kr.extLookup === EXT_LOOKUP.GOOGLE_SPREADSHEET
      trackCheckinEvent(
        this.$store.getters.user.id,
        this.goal,
        this.kr,
        { source: this.source, isCheckinOverdue: this.isCheckinOverdue, isLinkedToGoogleSheet },
        EVENT_NAME.KR_ACTIVITY_MODAL
      )
    },
    triggerReply(event) {
      this.$refs.krUpdates.triggerReply(event)
    }
  },
  async mounted() {
    await this.fetchEvents()
    this.$nextTick(() => focusEventNode(this.eventToFocus))
    this.listenToEventBus(events.KR_COMMENT_ADDED, this.fetchEvents)
    this.isCheckinOverdue = this.kr.isCheckinOverdue
  }
}
</script>

<style lang="scss" scoped></style>
